import { Pipe, PipeTransform } from '@angular/core';

/**
 * used to format route params that be null or undefined e.g. salesOrderId == null which will cause an error when routed
 */
@Pipe({
  name: 'routeParam'
})
export class RouteParamPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value == null || value == undefined) ? 0 : value;
  }
}
